import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "steps" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_list = _resolveComponent("app-list")!
  const _component_app_step = _resolveComponent("app-step")!
  const _component_app_steps = _resolveComponent("app-steps")!
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_info_box, {
      class: "estimation-workflow",
      title: "So funktioniert die Bewertung",
      "is-grey": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_steps, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_step, {
              number: "1",
              title: "Das benötigt der Rechner von dir"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_list, { list: $data.neededInformation }, null, 8, ["list"])
              ]),
              _: 1
            }),
            _createVNode(_component_app_step, {
              number: "2",
              title: "Schätzwert wird berechnet"
            }),
            _createVNode(_component_app_step, {
              number: "3",
              title: "Bewertung sofort per E-Mail erhalten"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}